var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBluetooth = function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.3 13.992-8.58-8.58c-1.26-1.26-3.42-.38-3.42 1.4v12.36l-7.78-7.78c-.78-.78-2.04-.78-2.82 0-.78.78-.78 2.04 0 2.82l9.78 9.78-9.78 9.78c-.78.78-.78 2.04 0 2.82.78.78 2.04.78 2.82 0l7.78-7.78v12.36c0 1.78 2.16 2.68 3.42 1.42l8.58-8.6c.78-.78.78-2.04 0-2.82l-7.18-7.18 7.18-7.16c.78-.78.78-2.06 0-2.84Zm-8-2.34 3.76 3.76-3.76 3.76v-7.52Zm3.76 20.92-3.76 3.76v-7.52l3.76 3.76Z",
    fill: "#282828"
  })));
};
export default SvgBluetooth;